import { Page } from '../../../../../components/page/page';
import { RestoreModal } from '../../../../../features/restore-modal/restore-modal';
import { CreateEmployeeModal } from './create-employee-modal/create-employee-modal';
import { DeleteEmployeeModal } from './delete-employee-modal/delete-employee-modal';
import { EmployeesCards } from './employees-cards/employees-cards';
import { EmployeesControls } from './employees-controls/employees-controls';
import { EmployeesTable } from './employees-table/employees-table';
import s from './employees.module.css';
import { QrCodeEmployeeModal } from './qr-code-employee-modal/qr-code-employee-modal';
import { UnlinkEmployeeModal } from './unlink-employee-modal/unlink-employee-modal';
import { useEmployees } from './use-employees';

export const Employees = () => {
  const {
    createEmployeeModal,
    deleteEmployeeModal,
    unlinkEmployeeModal,
    qrEmployeeModal,
    t,

    restoreEmployee,
    pagination,
    viewStyle,
    handleEnd,
  } = useEmployees();

  return (
    <Page className={s.page}>
      <div className={s.header}>
        <h2 className={s.title}>
          {t('Ваши сотрудники') + `${pagination ? `(${pagination.count})` : ''}`}
        </h2>
        <EmployeesControls />
      </div>

      {viewStyle === 'table' ? <EmployeesTable /> : <EmployeesCards onEnd={handleEnd} />}

      <RestoreModal onSubmit={restoreEmployee} />

      {createEmployeeModal.isOpen && (
        <CreateEmployeeModal onClose={() => createEmployeeModal.handleCloseModal(['id'])} />
      )}
      {deleteEmployeeModal.isOpen && (
        <DeleteEmployeeModal onClose={() => deleteEmployeeModal.handleCloseModal(['id', 'name'])} />
      )}
      {qrEmployeeModal.isOpen && (
        <QrCodeEmployeeModal
          onClose={() => qrEmployeeModal.handleCloseModal(['id', 'staffName', 'type'])}
        />
      )}
      {unlinkEmployeeModal.isOpen && (
        <UnlinkEmployeeModal onClose={() => unlinkEmployeeModal.handleCloseModal(['id', 'name'])} />
      )}
    </Page>
  );
};
